import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import useFeatureActions from '../../hooks/APIHooks/users/useFeatureActions';
import AcademiaButton from '../CommonComps/Buttons/AcademiaButton';
import CreateEditAssociateModal from '../CommonComps/Modals/CreateEditAssociateModal';

const CreateAssociateAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // integration of custom API hooks here
  const { getFeatureListHandler } = useFeatureActions('getFeatureList');

  // rendering create user action component here
  return (
    <div>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Create Associate
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditAssociateModal
            title='create associate'
            featureList={getFeatureListHandler.data?.data || []}
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateAssociateAction;
